// US2163904: Exec Summary and PIR links on a resolved incident (Eternium only).
import { authFetch } from "../utils/authFetch";

const BASE_URL = "/api/v1";

export const ARTIFACT_KINDS = {
  EXEC_SUMMARY: "exec_summary",
  PIR: "pir",
};

const GENERIC_ERROR = "Something went wrong. Please try again.";

// User-facing outcomes come back as {"error": "..."} and are safe to show. The 403 from the
// privilege gate is plain text, so it falls through to the generic message.
async function handleResponse(response) {
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || GENERIC_ERROR);
  }
  return response.json();
}

// fetch rejects with the browser's own text ("Failed to fetch"), which is not for users.
async function request(url, options) {
  try {
    return await authFetch(url, options);
  } catch (err) {
    // authFetch signals an expired session through the global 401 handler before it throws.
    if (err && err.status === 401) throw err;
    throw new Error(GENERIC_ERROR);
  }
}

const artifactsUrl = (problemNumber) =>
  `${BASE_URL}/problem/${encodeURIComponent(problemNumber)}/artifacts`;

export const incidentArtifactService = {
  /** @returns {Promise<{kind: string, externalUrl: string, updatedAt: string}[]>} */
  async getArtifacts(problemNumber) {
    const response = await request(artifactsUrl(problemNumber), { method: "GET" });
    const body = await handleResponse(response);
    return body.artifacts || [];
  },

  async saveArtifact(problemNumber, kind, externalUrl) {
    const response = await request(`${artifactsUrl(problemNumber)}/${kind}`, {
      method: "PUT",
      body: JSON.stringify({ externalUrl }),
    });
    return handleResponse(response);
  },

  async clearArtifact(problemNumber, kind) {
    const response = await request(`${artifactsUrl(problemNumber)}/${kind}`, {
      method: "DELETE",
    });
    return handleResponse(response);
  },
};
